import { FleetType, memoize } from '@jucy-ui/common';
import { addMinutes } from 'date-fns';
import { getLeadTimeHours } from './getLeadTimeHours';

export const addLeadTime = memoize(({ date, fleetType }: { date: Date; fleetType?: FleetType }) => {
    const leadTimeHours = getLeadTimeHours({ fleetType });
    return addMinutes(date, leadTimeHours * 60);
});
